module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "simple-filter-and-block"
  }, [_c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "blockTop"
  }, [_c('select', {
    domProps: {
      "value": _vm.expression.type
    },
    on: {
      "change": _vm.setType
    }
  }, _vm._l((_vm.possibleOperators), function(operator) {
    return _c('option', {
      domProps: {
        "value": operator.name
      }
    }, [_vm._v(_vm._s(operator.title))])
  })), _vm._v(" "), (_vm.parent) ? _c('button', {
    staticClass: "mdl-button delete-button",
    on: {
      "click": _vm.deleteThis
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("delete_forever")]), _vm._v(" Delete\n        ")]) : _vm._e()]), _vm._v(" "), _vm._l((_vm.expression.args), function(arg, argId) {
    return _c('div', {
      staticClass: "arg"
    }, [(argId > 0) ? _c('div', {
      staticClass: "andLine"
    }, [_vm._v("AND"), _c('div', {
      staticClass: "line"
    })]) : _vm._e(), _vm._v(" "), _c('FilterExpression', {
      attrs: {
        "expression": arg,
        "columns": _vm.columns,
        "parent": _vm.definition
      },
      on: {
        "update:expression": function($event) {
          _vm.setArg(argId, $event)
        },
        "delete": function($event) {
          _vm.deleteArg(argId)
        },
        "addAnd": function($event) {
          _vm.addArg(argId)
        }
      }
    })], 1)
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-51b6f342"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/query/SimpleFilterAndBlock.vue
// module id = 446
// module chunks = 0